var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('button',{staticClass:"k-button k-grid-edit-command",class:[_vm.readonly || _vm.disabled ? 'disabled' : ''],on:{"click":_vm.editHandler}})])}
var staticRenderFns = []

export { render, staticRenderFns }